import { YieldFetcher } from '../../types'

const SAVAX_URL = 'https://api.benqi.fi/liquidstaking/apr'

export const savaxFetcher: YieldFetcher = {
  label: 'SAVAX',
  fetch: async () => {
    const res = await fetch(SAVAX_URL).then((r) => r.json())
    return { SAVAX: Number(res.apr) * 100 }
  },
}
